import { useMsal } from "@azure/msal-react";
import { CustomerRuleOutcome } from "../../../../../dto/admin-rule-models";
import { useEffect, useState } from "react";
import { QualificationFlow } from "../../../../../dto/qualifying-flow-models";
import { GetAccessToken } from "../../../../../utils/auth-utils";
import { getQualificationFlows } from "../../../../../services/admin-page-service";
import { scopes } from "../../../../../authConfig";
import { Select } from "antd";

type SetQualificationFlowProps = {
  outcome: CustomerRuleOutcome
  onChange: (outcome: string) => void;
};

export const SetQualificationFlow = ({ outcome, onChange }: SetQualificationFlowProps) => {
  const { instance, inProgress, accounts } = useMsal();
  const [ flows, setFlows ] = useState<QualificationFlow[]>([]);
  
  useEffect(() => {
    const fetchData = async () => {
      const token = await GetAccessToken(instance, inProgress, scopes.salesAppointmentApi);
      const [flowsResult] = await Promise.all([
        getQualificationFlows(token.accessToken)
      ]);
      if (flowsResult.isSuccess) setFlows(flowsResult.data ?? []);
    };

    fetchData();
  }, []);
  
  return (
    <Select
      placeholder="Value"
      value={outcome.actionValue}
      onChange={onChange}
      style={{ width: "100%" }}
      showSearch
      allowClear
    >
      {flows.map(flow => (
        <Select.Option key={flow.id} value={flow.id.toString()}>
          {flow.name}
        </Select.Option>
      ))}
    </Select>
  );
};